import { DatePipe, NgStyle, NgIf, SlicePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Incidencias } from 'src/app/shared/model/incidencias/incidencia.model';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
    selector: 'app-card-inc',
    templateUrl: './card-inc.component.html',
    providers: [DatePipe],
    imports: [MatTooltip, NgStyle, NgIf, SlicePipe]
})
export class CardIncComponent implements OnInit, OnDestroy {
 
  constructor(
    private router: Router,
  ) {}

  @Input()  inc: Incidencias;
  @Input() color: String;
  @Input() proyecto: any

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  public number (valor: number): boolean {
    return (valor > Constantes.CERO);
  }

  detallesIncidenciaDesa(row: Incidencias) {
    this.router.navigate(['/INCIDENCIAS/INC_DESARROLLO/detalle', row.id], {
      state: { incidencia: row, proyecto: this.proyecto }
    });
  }

  
 
 


  

  
  }
  
